import React from "react";
import Sidebar from "../components/trackweb/Sidebar/Sidebar";
import RegisterSale from "../components/trackweb/RegisterSale/RegisterSale";
import { Navigate } from "react-router-dom";
import useTrackWebContext from "../hooks/useTrackWebContext";

const TrackWeb = () => {
  const { isLogin, infoCommerce } = useTrackWebContext();
  const userRole = infoCommerce?.rol;

  if (!isLogin) {
    return <Navigate to="/login" replace />;
  }
  return (
    <main className="track-web min-h-screen relative bg-[#f9f9f9]">
      <div
        className={`
          flex 
          ${(userRole === "comercio" || userRole === "colaborador") ? "flex-col lg:flex-row" : "flex-col items-center"} 
          items-start
          font-body
          w-full
          p-4
          lg:min-h-[101vh]
          xl:max-w-[1388px] xl:pt-[52px] xl:px-[50px] xl:pb-[50px]
          m-auto
        `}
      >
        <Sidebar />
        {(userRole === "comercio" || userRole === "colaborador") && <RegisterSale />}
      </div>
    </main>
  );
};

export default TrackWeb;